import { useState, useCallback } from 'react';
import { message } from 'antd';
import { p930hApi, F90H } from '../../../services/p930hApi';

export type CalendarMode = 1 | 2; // 1=single month, 2=cross-month

export function useCalendarQuery() {
  const now = new Date();
  const [year, setYear] = useState(now.getFullYear());
  const [month, setMonth] = useState(now.getMonth() + 1);
  const [calMode, setCalMode] = useState<CalendarMode>(1);
  const [events, setEvents] = useState<F90H[]>([]);
  const [queryLoading, setQueryLoading] = useState(false);
  const [queried, setQueried] = useState(false);

  const executeQuery = useCallback(async () => {
    if (year < 1900 || year > 9999) {
      message.error('年份範圍 1900~9999');
      return;
    }
    if (month < 1 || month > 12) {
      message.error('月份範圍 1~12');
      return;
    }
    setQueryLoading(true);
    try {
      const res = await p930hApi.queryCalendar({ year, month, mode: calMode });
      setEvents(res.data || []);
      setQueried(true);
      if ((res.data || []).length === 0) {
        message.info('查無行事曆資料');
      }
    } catch (e: unknown) {
      const err = e as { response?: { data?: { errors?: { message: string }[]; error?: string } } };
      const errors = err.response?.data?.errors;
      if (errors && Array.isArray(errors)) {
        message.error(errors.map(x => x.message).join('\n'));
      } else {
        message.error(err.response?.data?.error || '查詢失敗');
      }
    } finally {
      setQueryLoading(false);
    }
  }, [year, month, calMode]);

  return {
    year, setYear,
    month, setMonth,
    calMode, setCalMode,
    events, queryLoading, queried,
    executeQuery,
  };
}
